/* ----- cart.js ----- */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {}

  disconnectedCallback() {}

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const sectionEL = document.getElementById(section.id);
          if (!sectionEL) return;

          const elementToReplace = sectionEL.querySelector(section.selector) || sectionEL;
          if (!elementToReplace) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';

        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(error => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (!errors) return;
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      if (typeof message !== 'undefined' && message !== '') lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return;

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!(html || selector)) return;
    const $selector = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!$selector) return;
    return $selector.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems.classList.add('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.add('loading'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems?.classList.remove('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.remove('loading'));
    document.dispatchEvent(new CustomEvent('CartItemsOnChange'));
    document.dispatchEvent(new CustomEvent('cart-disable-loading'));
  }
};

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* ----- quantity-popover.js ----- */
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.variantInfo = this.querySelector('.quantity-popover-container');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isExpanded);

        this.popoverInfo.toggleAttribute('hidden');

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        button.classList.toggle('quantity-popover__info-button--open');

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isChild = this.variantInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

/* ---- cart-drawer.js ----- */
class CartDrawer extends HTMLElement {
  constructor() {
    if (window.CartDrawerInit) return;

    super();
    window.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        if (document.documentElement.classList.contains('cart-drawer--active')) {
          this.close();
        }
        if (window.SLIDECART_CLOSE && typeof window.SLIDECART_CLOSE === 'function') {
          window.SLIDECART_CLOSE()
        }
      }
    })
    this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    window.CartDrawerInit = true;
  }

  setHeaderCartIconAccessibility() {
    if (window.location.pathname === '/cart') return;

    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    /* cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    }); */
  }

  open(triggeredBy) {
    document.dispatchEvent(new CustomEvent('cart-drawer-opened'));

    cartDrawerInner.scroll(0, 0);

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    requestAnimationFrame(() => {
      lockScrollEnable();
      document.documentElement.classList.add('cart-drawer--active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        window.updateCartCount();
      },
      { once: true }
    );
  }

  close() {
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    document.documentElement.classList.remove('cart-drawer--active');
    lockScrollDisable();
    window.updateCartCount();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart-drawer-closed'));
    }, 250);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
      this.open();

      if (document.querySelector('#cartDrawerInner [data-swiper]')) {
        if (typeof window.loadSwiper === 'function') {
          window.loadSwiper();
        } else if (typeof window.swipers === 'function') {
          window.swipers();
        }
        setTimeout(() => {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => window.removeCartItemsFromUpsell(cart))
            .catch(error => console.error('Error fetching cart:', error));
        }, 100);
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.quickviewEl = this.closest('#quickview-modal');
    this.containerEl = this.closest('product-detail') || this.quickviewEl;
    this.formEls = this.containerEl.querySelectorAll(`[data-pdp-form="${this.dataset.section}"]`);

    this.addEventListener('change', this.onVariantChange);
    this.limitedUpdate = this.hasAttribute('data-limited-update') && this.dataset.limitedUpdate === 'true';
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.setUnavailable();
      return
    }

    this.toggleAddButton({ disable: !this.currentVariant || !this.currentVariant.available });
    this.updateSku();
    this.updateOptionsLegend();
    this.updateVariantInput();
    this.renderProductInfo();

    if (!this.limitedUpdate && !this.quickviewEl) {
      this.updateURL();
    } else {
      this.updateSetInputs();
    }
  }

  updateBis(html) {
    this.bisContainer = this.containerEl.querySelector('[data-bis-modal-container]');
    if (!this.bisContainer || this.currentVariant.available) return;

    const source = html.querySelector('[data-bis-modal-container]');
    if (!source) return;

    this.bisContainer.innerHTML = source.innerHTML;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionsLegend() {
    this.currentVariant.options.forEach((option, index) => {
      const replaceText = this.getOptionNameReplaceText() && this.getOptionNameReplaceText().find(o => option === o.title);
      const el = this.querySelector(`[data-product-option-active="${index}"]`);
      el ? el.innerText = replaceText ? replaceText.replace : option : null;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    window.publish(PUB_SUB_EVENTS.variantChange, {
      sectionId: this.dataset.section,
      currentVariant: this.currentVariant,
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSku() {
    this.skuEl = this.skuEl || this.containerEl?.querySelector('#productSku')
    if (!(this.currentVariant && this.skuEl)) return;
    this.skuEl.innerText = 'Style Number: ' + this.currentVariant.sku.split('-')[0];
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const sectionId = this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (!this.currentVariant.available) this.updateBis(html);

        const id = `price-${sectionId}`;
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton({ disable: !this.currentVariant.available, text: window.variantStrings.soldOut || 'Sold out' });
      });
  }

  toggleAddButton({ disable = true, text = null } = {}) {
    const addButton = this.containerEl?.querySelector('[name="add"]');

    if (!addButton) return;
    this.updateFormClasses();

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-json="product-variants"]').textContent);
    return this.variantData;
  }

  getOptionNameReplaceText() {
    this.optionNameReplaceText = this.optionNameReplaceText || JSON.parse(this.querySelector('[type="application/json"][data-json="option-name-replace-text"]').textContent);
    return this.optionNameReplaceText;
  }

  updateFormClasses() {
    if (this.formEls.length) {
      this.formEls.forEach((formEl) => {
        formEl.classList.toggle('bis-active', !this.currentVariant.available);
      });
    } else {
      this.quickviewEl?.classList.toggle('bis-active', !this.currentVariant.available);
    }
  }

  updateSetInputs() {
    this.querySelectorAll(':checked').forEach(input => {
      const setInput = document.querySelector(`input[data-form-id="${input.getAttribute('form')}"][name$="id"]`);
      if (setInput) setInput.value = this.currentVariant.id;
    });
  }
};

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      return inputs.length === 1 ? inputs[0].value : inputs.length && inputs.find((radio) => radio.checked).value;
    });
  }
};

customElements.define('variant-radios', VariantRadios);

/* ----- globals ----- */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function lockScrollEnable() {
  window.pageY = window.scrollY;
  document.body.style.left = 0;
  document.body.style.right = 'var(--scrollbar-width)';
  document.body.style.top = `-${window.pageY}px`;
  document.body.style.position = 'fixed';
}

function lockScrollDisable() {
  let scrollY = window.pageY;
  const bodyTop = document.body.style.top;

  if (bodyTop) {
    scrollY = Math.abs(parseInt(bodyTop));
  } else if (scrollY === undefined || scrollY === null) {
    scrollY = window.scrollY;
  }

  document.body.style.position = null;
  document.body.style.left = null;
  document.body.style.right = null;
  document.body.style.top = null;
  window.scrollTo(0, scrollY);
}

function loadMinicart() {
  const cartDrawerInner = document.querySelector('#cartDrawerInner');
  if (!cartDrawerInner) return;

  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then(response => response.json())
    .then(data => {
      const parsedContent = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('#cartDrawerInner');
      if (parsedContent) {
        cartDrawerInner.innerHTML = parsedContent.innerHTML;
      }
    });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; /* If not TAB key */
    /* On the last focusable element and tab forward, focus the first element. */
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    /*  On the first focusable element and tab backward, focus the last element. */
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onBisButtonClick() {
        this.bisModal = this.closest('product-detail')?.querySelector('[data-bis-dialog-el]') || this.closest('#quickview-modal')?.querySelector('[data-bis-dialog-el]');
        if (!this.bisModal) return;
        this.bisModal.showModal();
      }

      onClick(event) {
        if (!event.target.closest('[data-bis-button]')) return;
        this.onBisButtonClick();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            this.closest('.quickadd--loading')?.classList.remove('quickadd--loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

(() => {
  const onScroll = () => {
    if (window.menuToggling) return;


    if (window.pageYOffset > window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled');
    } else {
      document.documentElement.classList.remove('header--scrolled');
    }

    if (window.pageYOffset > 30 + window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled--after');
    } else {
      document.documentElement.classList.remove('header--scrolled--after');
    }

    const scrollTop = window.pageYOffset;

    /* scroll direction */
    const scrollDifference = scrollTop - window.lastScrollTop;
    if (Math.abs(scrollDifference) > 1) {
      window.scrollDirection = scrollDifference > 0 ? 'down' : 'up';
      document.documentElement.dataset.scrollDirection = window.scrollDirection;
      window.lastScrollTop = scrollTop;
    }
  };

  const inViewVideo = (el, src) => {
    const $video = el.tagName === 'VIDEO' ? el : el.closest('video');

    if (!$video) return;
    if (typeof src !== 'undefined') $video.src = el.dataset.inViewVideoSrc;

    if (!$video.hasAttribute('data-autoplay')) return;
    /* $video.removeAttribute('controls'); */
    $video.play();
  };

  window.lazyLoadScript = obj => {
    const isLoaded = document.head.querySelector(`[data-in-view-script-name='${obj.src}']`);
    const cb = obj.callback && typeof window[obj.callback] === 'function' ? window[obj.callback] : null;

    if (isLoaded) {
      if (cb) cb();
      return;
    }

    if (!obj.hasOwnProperty('src')) {
      // only need to fire the callback, no script to load
      if (cb) cb();
      return;
    }

    const el = document.createElement('script');
    el.dataset.inViewScriptName = obj.src;
    el.type = obj.type || 'text/javascript';
    if (obj.defer) el.defer = true;
    else if (obj.async) el.async = true;
    el.src = obj.src;
    document.head.appendChild(el);

    if (cb) el.onload = requestAnimationFrame(() => {
      cb()
    });
  }

  const inViewScript = obj => {
    lazyLoadScript(obj);
  };

  window.loadSwiper = () => {
    /* load swiper if needed */
    if (!window.swiperLoaded && typeof Swiper !== 'function') {
      const $script = document.createElement('script');
      $script.async = true;
      $script.src = window.assetUrls['swiper.js'];
      document.head.appendChild($script);
      window.swiperLoaded = true
    }

    const swiperIsReady = new Promise(resolve => {
      let timer = setInterval(() => {
        if (typeof Swiper === 'function') {
          clearInterval(timer);
          return resolve();
        }
      }, 30)
    });

    swiperIsReady.then(() => {
      window.swipers();
    }).catch(error => {
      /* console.log('Something went wrong', error); */
    })
  };

  window.buildQuickAdd = (el, variants)  => {
    const $container = el.querySelector('[data-product-card-quickadd]');
    if (!$container) return;

    $container.innerHTML = '';
    let els = [];
    variants.forEach(variant => {
      const button = document.createElement('button');
      const span = document.createElement('span');
      const title = variant.available ? `Add ${variant.name} to cart` : `${variant.name} is out of stock`;
      button.type = 'button';
      if (!variant.available) button.setAttribute('disabled', 'disabled');
      button.classList = 'product-card__quickadd-btn';
      button.setAttribute('data-quickadd-variant', '');
      button.setAttribute('aria-label', title);
      button.setAttribute('title', title);
      button.setAttribute('onclick', `window.onQuickAdd(event.target, ${variant.id})`);
      span.setAttribute('aria-hidden', true);
      span.innerText = variant.title.split('/ ')[1].replace(/&#39;/g , "\'");
      button.appendChild(span);
      els.push(button);
      $container.appendChild(button);
    });
  };

  window.onQuickAdd = (el, variant) => {
    el.closest('.product-card').classList.add('quickadd--loading');
    const $form = el.closest('form');
    const id = $form.querySelector('[name="id"]');
    id.value = variant;
    el.closest('form').dispatchEvent(new Event('submit'));
    /* window.addToCart($form); */
  };

  /* product-card: update card on swatch click */
  window.onSwatchClick = e  => {
    if (e.target.classList.contains('swatches__item--active')) return;

    e.preventDefault();

    const alreadyClicked = e.target.classList.contains('clicked');
    const data = JSON.parse(e.target.dataset.swatch);
    let img;

    /* make request for image */
    if (!alreadyClicked) {
      img = new Image();
      img.src = data.images[0].src;
      e.target.classList.add('clicked');
    }

    const $card = e.target.closest('[data-product-card]');

    /* build swatches */
    buildQuickAdd($card, data.variants);

    /* loading state: begin */
    $card.classList.add('product-card--loading');

    /* swatch active class: remove previous */
    $card.querySelector('.swatches__item--active')?.classList.remove('swatches__item--active');

    /* swatch active class: add to clicked swatch */
    e.target.classList.add('swatches__item--active');

    /*
      update card via swatch data
    */

    /* update card: image */
    $card.querySelectorAll('[data-product-card-image]').forEach((el, index) => {
      const $src = el.querySelector('[data-product-card-image-src]');
      const $srcset = el.querySelector('[data-product-card-image-srcset]');
      $src.alt = data.images[index].alt;
      $src.src = data.images[index].src;
      $src.srcset = data.images[index].srcset;
      $srcset.srcset = data.images[index].srcsetLarge;
    });

    /* update card: url */
    const $url = $card.querySelector('[data-product-card-url]');
    $url.href = data.url;

    /* update card: url title attribute */
    $url.title = `View ${data.title} in ${data.variantName} product details`;

    /* update card: price */
    if (data.priceCompareAtAmount > data.priceAmount) {
      $card.querySelector('[data-product-card-price-compare]').innerHTML = data.priceCompareAt;
      $card.querySelector('[data-product-card-price-regular]').innerHTML = data.price;
    } else {
      $card.querySelector('[data-product-card-price-compare]').innerHTML = '';
      $card.querySelector('[data-product-card-price-regular]').innerHTML = data.price;
    }

    /* update card: title */
    $card.querySelector('[data-product-card-title]').innerText = data.title.replace(/&lt;br&gt;/g, "\n").replace(/&#39;/g , "\'");

    /* update card: variant name */
    $card.querySelector('[data-product-card-variant-name]').innerText = data.variantName;

    /* loading state: end */
    if (alreadyClicked) {
      setTimeout(() => {
        $card.classList.remove('product-card--loading');
      }, 200);
    } else {
      img.onload = () => {
        setTimeout(() => {
          $card.classList.remove('product-card--loading');
        }, 200);
      }
    }
  };

  window.publishProductsData = data => {
    /* USAGE:
      window.addEventListener('publishProductsData', data => {
        console.log('<gtm-helper> publishProductsData listener', data.detail);
      });
    */
    window.dispatchEvent(new CustomEvent('publishProductsData', {
      detail: data,
    }));
  };

  /* swipers init via data-swiper={options} */
  window.swiperEls = [];
  window.swipers = () => {
    document.querySelectorAll('[data-swiper]:not(.swiper-initialized)').forEach((el, index) => {
      window.swiperEls[index] = new Swiper(el, Object.assign({}, {
        a11y: true,
        observer: true,
        slidesPerView: 'auto',
        threshold: 8,
      }, JSON.parse(el.dataset.swiper)));

      const changeEvent = el.getAttribute('data-swiper-slide-change');

      if (changeEvent && window.hasOwnProperty(changeEvent) && typeof window[changeEvent] === 'function') {
        window.swiperEls[index].on('slideChange', function(e) {
          window[changeEvent](e);
        })
      }
    });
  };

  window.inView = () => {
    /* add .in-view class to [data-in-view] els as they enter the viewport */
    const inViewEls = document.querySelectorAll('[data-in-view]');

    const inViewObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');

          if (entry.target.hasAttribute('data-autoplay') || entry.target.hasAttribute('data-in-view-video-src')) {
            inViewVideo(entry.target, entry.target.dataset.inViewVideoSrc);
          }

          if (entry.target.hasAttribute('data-in-view-swiper')) {
            loadSwiper();
            inViewObserver.unobserve(entry.target);
          }

          if (entry.target.hasAttribute('data-in-view-script')) {
            inViewScript(JSON.parse(entry.target.dataset.inViewScript));
          }
        } else {
          if (entry.target.tagName === 'VIDEO' && entry.target.paused == false) {
            entry.target.pause()
          }
        }
      });
    });

    inViewEls.forEach(el => inViewObserver.observe(el));
  };

  const addAriaLabelToCartBg = () => {
    setTimeout(() => {
      const cartBgEl = document.querySelector('.slidecarthq-overlay');
      if (cartBgEl) cartBgEl.setAttribute('aria-label', 'Close cart');
    }, 500);
  };

  document.addEventListener('DOMContentLoaded', () => {
    customElements.define('cart-remove-button', CartRemoveButton);
    customElements.define('cart-items', CartItems);
    customElements.define('cart-drawer', CartDrawer);

    window.lastScrollTop = window.pageYOffset;

    addAriaLabelToCartBg();

    onScroll();
    inView();

    window.addEventListener('scroll', () => {
      onScroll();
    }, { passive: true });
  });

  window.addEventListener('load', e => {
    addAriaLabelToCartBg();
  });

  window.addEventListener('keyup', e => {
    if (e.key === 'Escape') document.dispatchEvent(new CustomEvent('onEsc'));
  });
  

  window.updateCart = (openCart = false) => {
    /* reload the minicart */
    if (document.querySelector("#cartDrawerInner")) {
      window.loadMinicart();

      if (openCart) {
        /* open the minicart */
        document.querySelector('cart-drawer')?.open();
      }
    } else {
      /* reload the cart page */
      document.querySelector('cart-items')?.onCartUpdate();
    }

    /* update cart bubble count in header */
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.querySelector('#cart-icon-bubble').innerHTML = html.querySelector('#shopify-section-cart-icon-bubble').innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });

    /* update free shipping message in announcement bar */
    fetch(`${routes.cart_url}.js`)
      .then(response => response.json())
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form-cart-total',
          cartData: data,
        });
      });
  };


  window.updateCartCount = (delay = 300) => {
    requestAnimationFrame(() => {
      const $count = document.querySelector('[data-cart-icon-bubble-count]');
      const count = $count ? $count.innerText : 1
      // /* wait for cart-drawer transition to finish then update data-cart-count which is used to adjust the padding next to cart icon in header*/
      if (window.useThemeCart == true) {
        setTimeout(() => {
          document.documentElement.dataset.cartCount = count
        }, delay);
      }
    });
  }

  window.updateCartFilledState = () => {
    const cartIcon = document.querySelector('.nav__icon--cart');
    const cartCountElement = document.querySelector('[data-cart-icon-bubble-count]');
    let cartCount = 0;

    if (cartCountElement) {
      const countText = cartCountElement.innerText.replace(/[()]/g, '');
      cartCount = parseInt(countText) || 0;
    }

    if (cartIcon) {
      if (cartCount > 0) {
        cartIcon.classList.add('nav__icon--cart-filled');
      } else {
        cartIcon.classList.remove('nav__icon--cart-filled');
      }
    }
  }

  document.addEventListener('CartItemsOnChange', () => {
    window.updateCartFilledState();
    window.updateCartCount();
    window.updateCart()
  })

  document.addEventListener('cart-drawer-closed', () => {
    setTimeout(() => {
      window.updateCartFilledState();
    }, 100);
  })

  const cartCountElement = document.querySelector('[data-cart-icon-bubble-count]');
  if (cartCountElement) {
    const observer = new MutationObserver(() => {
      window.updateCartFilledState();
    });
    observer.observe(cartCountElement, { childList: true, characterData: true, subtree: true });
  }

  window.updateCartFilledState();

  if (window.useThemeCart == false) {
    window.SLIDECART_UPDATED = function(cart) {
      window.updateCart()
    }

    window.SLIDECART_OPENED = function() {
      const slideCart = document.getElementById('slidecarthq');
      if (slideCart) {
        window.slideCartActiveElement = document.activeElement;

        const closeButton = slideCart.querySelector('.header button');
        if (closeButton) {
          trapFocus(slideCart, closeButton);
        }
      }
    }

    window.SLIDECART_CLOSED = function() {
      removeTrapFocus(window.slideCartActiveElement);
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.close();
      }
    }
  }

})();